import {
  Anchor,
  AppShellFooter,
  AppShellMain,
  AppShell as BaseAppShell,
} from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router-dom"

import classes from "~/assets/css/SuppplierHeader.module.css"
import { SupplierAppHeader } from "~/components/layout/SupplierAppHeader"
import { useSupplierCrispChat } from "~/components/layout/useSupplierCrispChat"

export const SupplierAppShell = () => {
  const { t } = useTranslation()
  useSupplierCrispChat()

  return (
    <BaseAppShell
      padding={0}
      layout="alt"
      header={{ height: "var(--mantine-supplier-header-height)" }}
    >
      <SupplierAppHeader />
      <AppShellMain>
        <Outlet />
      </AppShellMain>
      <AppShellFooter className={classes["supplier-footer"]} p="sm">
        <Anchor
          href="https://www.traceforgood.com/privacy-policy"
          target="blank"
          fz="xs"
        >
          {t("supplier.footer.privacyPolicy")}
        </Anchor>
      </AppShellFooter>
    </BaseAppShell>
  )
}
